module.exports = __webpack_public_path__ + "static/apps-e1a427c8da5cdd9971a3343d05d56a4f.png";